import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<AddProductAttributesSuccessStep>({})
export default class AddProductAttributesSuccessStep extends Vue {
  // #region @Props

  @Prop({ default: '1' })
  protected step!: string;

  @Prop({ default: true })
  protected isLoading!: boolean;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Handlers

  protected onCloseButtonClick(): void {
    this.$emit('close');
  }

  // #endregion

  // #region Helpers
  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces
// #endregion
